export enum ReportScope {
  ENTITY = 'Entity',
  ECONOMY = 'Economy',
  MARKET = 'Market',
}

export interface IReportType {
  id: number;
  name: string;
  reportScope: ReportScope;
}
